<template>
<div style="background:#fcfcfd">
<div class="container">
<div style="padding-top:20px"><span style="cursor:pointer" @click="gotoHome()">HOME</span> - PRODUCT - {{categoryName}}</div>
    <div class="row" style="padding:30px 0px;padding-top:15px;">
        <div class="col-md-3">
            <left></left>
        </div>
        <div class="col-md-9" style="color:#888;font-size:15px;line-height:25px;">
            
            <div class="row" v-if="category == '1'">
                    
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product114_logo.jpg" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('114')">{{$t('home_product_section_1')}}</a>
                            </div>
                        </div>
                    </div>
                    
            </div>
            <div class="row" v-if="category == '2'">
                    
                    
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product115_logo.jpg" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('115')">{{$t('home_product_section_2')}}</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product107_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('107')">{{$t('home_product_section_5')}}</a>
                            </div>
                        </div>
                    </div>
            </div>

            <div class="row" v-if="category == '3'">
                     <!-- <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product118_logo.jpg" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('118')"> PVC  Resin</a>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product57_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('57')">{{$t('home_product_section_3')}}</a>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product59_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('59')"> CPE 135A</a>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product63_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('63')">ACR</a>
                            </div>
                        </div>
                    </div>
                    
                    
             </div>
            <div class="row" v-if="category == '3'">
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product118_logo.jpg" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('118')"> PVC  Resin</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product61_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('61')">{{$t('home_product_section_4')}}</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product60_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('60')"> PE wax</a>
                            </div>
                        </div>
                    </div>
                   
            </div>

            <div class="row" v-if="category == '3'">
                    
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product71_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('71')"> Optical brightener</a>
                            </div>
                        </div>
                    </div>
                    
                
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product96_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('96')"> Nano calcium carbonate</a>
                            </div>
                        </div>
                    </div>
            </div>

            <div class="row" v-if="category == '5'">
                    
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product69_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('69')"> Sodium Acid Pyrophosphate SAPP</a>
                            </div>
                        </div>
                    </div>
                    
            </div>

            <div class="row" v-if="category == '4'">
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product117_logo.jpg" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('117')"> Purified Terephthalic Acid</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product70_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('70')"> Dicyandiamide</a>
                            </div>
                        </div>
                    </div>
                    
                 <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product108_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('108')"> Fumed Silica</a>
                            </div>
                        </div>
                    </div>

                    
                   
                    
                </div>
            <div class="row" v-if="category == '4'">
                    
                   
                    
                    
                     <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product106_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('106')"> silicon carbide abrasive</a>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product79_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('79')"> Poly Aluminium Chloride (PAC)</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product56_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('56')"> Magnesium hydroxide</a>
                            </div>
                        </div>
                    </div>
              
                </div>
            <div class="row" v-if="category == '4'">
                    
                   
                    
                  <div class="col-md-4 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product66_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="product-title">
                                <a @click="jumpProduct('66')"> Barium Sulfate</a>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>
</div>
</template>

<script>

import left from './left';
import bus from '../util/bus';
export default {
    created(){
    
    },
    mounted(){
        this.resetCategory();
        bus.$on('changecategory',()=>{
            this.resetCategory();
        });
    },
    components: {
        left
    },
    
    data(){
        return{
            category:"1",
            categoryName:"Aluminium Hydroxide"
        }
    },
    methods:{
        gotoHome(){
            this.$router.push('/');
        },
        jumpProduct(id){
            this.$router.push('product?id='+id);
            bus.$emit('changeproduct');
        },
        resetCategory(){
            let id = this.getSearchString('id');
            if(id == "2"){
                this.categoryName = "Boron Nitride";
            }
            else if(id == "3"){
                this.categoryName = "PVC Materials";
            }
            else if(id == "4"){
                this.categoryName = "Raw Materials";
            }
            else if(id == "5"){
                this.categoryName = "Food Additives";
            }
          

            this.category = id;
        },
        getSearchString(key){
            var str = location.href.substring(location.href.indexOf('?'));
            str = str.substring(1, str.length);


            var arr = str.split("&");
            var obj = new Object();
 
            for (var i = 0; i < arr.length; i++) {
                var tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
            }
            return obj[key];
        },
    }
};
</script>

<style>
.navbar-brand-img{
    width: 150px;
    height:auto;
}
</style>



// WEBPACK FOOTER //
// category.vue?7487d88f